




































































import { TbMember, TbReturnOrder } from '@/http';
import { Component, Vue, Watch,Prop } from 'vue-property-decorator';
import { fmoney } from '@/common/money';
import calculate from '@/common/util/calculate';
import { Toast } from 'vant';
@Component({
    components: {
    },
})
export default class mulChangePricePanel extends Vue {
    public $refs: {
    };
   

    @Prop({
        type:Object,
        default:()=>{
            return{
                id:"",
                name:"",
                gradeDiscount:null,
            }
        }
    })
    memberInfo;

    show=false;
   
    fmoney = fmoney;

    /**键盘 */
    value=null;
    maxLength=3;

    goodDiscount= null;

    config={
        loop : [
            {
                number : 1,
                key : 'number-1',
            },
            {
                number : 2,
                key : 'number-2',
            },
            {
                number : 3,
                key : 'number-3',
            },
            {
                number : 4,
                key : 'number-4',
            },
            {
                number : 5,
                key : 'number-5',
            },
            {
                number : 6,
                key : 'number-6',
            },
            {
                number : 7,
                key : 'number-7',
            },
            {
                number : 8,
                key : 'number-8',
            },
            {
                number : 9,
                key : 'number-9',
            },
        ]
    }

    /**商品折扣 */
    goodDiscountOptions=[
        {
            label:'以商品为准',
            value:null,
        },
        {
            label:'均无折扣',
            value:1,
        },
        {
            label:'打折',
            value:2,
        },
    ]
    goodDiscountVal = null;
    /**会员折扣 */
    memberDiscountOptions=[
        {
            label:'以商品为准',
            value:null,
        },
        {
            label:'均不参与',
            value:1,
        },
        {
            label:'全部参与',
            value:2,
        },
    ]
    memberDiscountVal=null;
    /**整单折扣 */
    discountOptions=[
        {
            label:'以商品为准',
            value:null,
        },
        {
            label:'均不参与',
            value:1,
        },
        {
            label:'全部参与',
            value:2,
        },
    ]
    discountVal=null;
    /**赠送积分 */
    integralOptions=[
        {
            label:'以商品为准',
            value:null,
        },
        {
            label:'均不参与',
            value:1,
        },
        {
            label:'全部参与',
            value:2,
        },
    ]
    integralVal=null;

    created() {
    }   
    
    mounted() {
       
    }
    showFun(){
        let mulChangePricegSet = localStorage.getItem('mulChangePricegSet')?JSON.parse(localStorage.getItem('mulChangePricegSet')):null;
        if(mulChangePricegSet){
            this.discountVal = mulChangePricegSet.discountVal;
            this.goodDiscount = mulChangePricegSet.goodDiscount;
            this.goodDiscountVal = mulChangePricegSet.goodDiscountVal;
            this.integralVal = mulChangePricegSet.integralVal;
            this.memberDiscountVal = mulChangePricegSet.memberDiscountVal;
        }else{
            this.discountVal = null;
            this.goodDiscount = null;
            this.goodDiscountVal = null;
            this.integralVal = null;
            this.memberDiscountVal = null;
        }
        this.show = true;
        
    }
    closeFun(){
        this.show = false;
    }
    saveFun(){

    }
    onChange(detail,type){
        switch (type) {
            case 1:
                this.goodDiscountVal = detail;
                this.clearFun();
                break;
            case 2:
                this.memberDiscountVal = detail;
                break;
            case 3:
                this.discountVal = detail;
                break;
            case 4:
                this.integralVal = detail;
                break;
        
            default:
                break;
        }
    }
    setNumVal(val){
        this.value = val;
    }

    del() {
		if(!this.value) return;
            let index = this.value.length;
            this.value = this.value.toString().slice(0,index-1);
            this.finishFun();
        }
	number(number) {
		let val = this.value;
		let dotIndex = this.value?this.value.toString().indexOf('.'):-1;
		if(number=='.'&&dotIndex>-1||this.value&&this.value.toString().length==this.maxLength) return;
		this.value = this.value?this.value.toString() + number.toString():number.toString();
		if(dotIndex>-1){
			if(val.toString().slice(dotIndex+1).length>1){
				this.value = this.value.slice(0,dotIndex+3)
			}
		}else{
			this.value = this.value.slice(0,this.maxLength)
		}
		this.finishFun();
	}


	clearFun(){
            this.value = null;
            this.finishFun();
    }
    finishFun(){
        console.log('sss',this.value);
        
        if(this.goodDiscountVal==2){
            if(this.value&&(Number(this.value)>9.9)){
                Toast("折扣请输入0.1-9.9");
                this.value=null;
            }
            this.goodDiscount = this.value;
        }
        this.$forceUpdate();
    }
    confirmFun(){
        if(this.goodDiscountVal==2&&(!this.goodDiscount||Number(this.goodDiscount)==0)){
            Toast("请输入折扣");
            return;
        }
        let obj = {
            goodDiscountVal:this.goodDiscountVal,
            goodDiscount:this.goodDiscount,
            memberDiscountVal:this.memberDiscountVal,
            discountVal:this.discountVal,
            integralVal:this.integralVal
        }
        localStorage.setItem('mulChangePricegSet',JSON.stringify(obj));
        this.$emit('mulChangePricegFun');
        this.closeFun();
    }
   
    
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/cashier/components/mulChangePricePanel.vue